import { Offline as OfflineUI, OfflineProps } from '@uy3/web-components';

const Offline = ({ ...props }: OfflineProps) => <OfflineUI {...props} />;
export default Offline;
